
export default {
  name: 'SurveyResultsSearchPanel',

  props: {
    surveysList: {
      type: Array,
      default: [],
    },
  },

  data() {
    return {
      isSubmitForm: false,
      searchParams: {
        name: '',
        number: '',
        answered_time: [],
      },
    };
  },

  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('changeFilterBy', newVal);
      },
      deep: true,
    },
  },

  methods: {
    async clearSearchParams() {
      this.searchParams.name = '';
      this.searchParams.number = '';
      this.searchParams.answered_time = [];
    },
  },
};
